import { backofficeRequest } from '../../../axios'

export default class ApiGetBudgetCompliance {
  async getAllCurrentYearBudgetsCompliance(
    page = 1,
    per = 25,
    orderBy,
    orderDirection,
    searchValue,
    selectedUsers = [],
    onlyCurrentUser = false
  ) {
    try {
      const newOrder = this.determineOrderByColumn(orderBy)
      // Offset in Back is the not the same as the Front
      const offsetPageBack = page + 1
      let url = `/backoffice/budgets-compliance?page=${offsetPageBack}&per=${per}&orderBy=${newOrder}&orderDirection=${orderDirection}&onlyCurrentUser=${onlyCurrentUser}`
      searchValue.length > 0 && (url += `&search=${searchValue}`)
      if (selectedUsers.length > 0) {
        const idsJson = encodeURIComponent(
          JSON.stringify(selectedUsers.map((user) => user.id))
        )

        url += `&userIds=${encodeURIComponent(idsJson)}`
      }

      const res = await backofficeRequest.get(url)
      return res.data
    } catch (error) {
      return []
    }
  }

  async getBudgetsComplianceBySearch(
    page = 1,
    per = 25,
    orderBy,
    orderDirection,
    searchValue
  ) {
    try {
      const newOrder = this.determineOrderByColumn(orderBy)

      // Offset in Back is the not the same as the Front
      const offsetPageBack = page + 1

      const res = await backofficeRequest.get(
        `/backoffice/budgets-compliance/search/${searchValue}?page=${offsetPageBack}&per=${per}&orderBy=${newOrder}&orderDirection=${orderDirection}`
      )
      return res.data
    } catch (error) {
      return []
    }
  }

  determineOrderByColumn(orderBy) {
    switch (orderBy) {
      case 'Copropriété':
        return 'name'
      case 'Copromatic Id':
        return 'copromaticId'
      case 'Etat Budgetaire':
        return 'budgetPercent'
      default:
        return undefined
    }
  }
}
